<template>
      <v-dialog v-model="open" :max-width="tamModal" :scrollable="$root.isTouch == false" fullscreen persistent>
            <v-card elevation="11">
                  <v-card-title class="bg-title-card">
                        <span class="white--text headline" v-html="obModal.titulo"></span>
                        <v-spacer></v-spacer>
                        <v-icon dark @click="close">close</v-icon>
                  </v-card-title>
                  <v-card-text>
                        <v-container fluid>

                              <v-row dense>
                                    <v-col cols="12" sm="4">
                                          <v-text-field dense label="Aseguradora" color="textbox"
                                                v-model="obModal.aseguradora" outlined readonly />
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                          <v-text-field dense label="Seguro" color="textbox" v-model="obModal.seguro"
                                                outlined readonly />
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                          <v-text-field dense label="Contratante" color="textbox"
                                                v-model="obModal.contratante" outlined readonly />
                                    </v-col>
                              </v-row>

                              <v-row dense>
                                    <v-col cols="12" sm="4">
                                          <v-text-field dense label="Póliza" color="textbox" v-model="obModal.poliza"
                                                outlined readonly />
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                          <v-text-field dense label="Fecha Desde" color="textbox"
                                                v-model="obModal.fechaDesde" outlined readonly />
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                          <v-text-field dense label="Fecha Hasta" color="textbox"
                                                v-model="obModal.fechaHasta" outlined readonly />
                                    </v-col>
                              </v-row>

                              <v-row dense>
                                    <v-col cols="12" sm="12">
                                          <v-text-field dense label="Asegurado" color="textbox" v-model="obModal.asegurado"
                                                outlined readonly />
                                    </v-col>                                    
                              </v-row>

                              <v-row dense>
                                    <v-col cols="12" sm="4">
                                          <v-text-field dense label="Valor Asegurado" color="textbox"
                                                :value="`$ ${obModal.valorAsegurado}`" outlined readonly />
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                          <v-text-field dense label="Prima Bruta" color="textbox"
                                                :value="`$ ${obModal.primaBruta}`" outlined readonly />
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                          <v-text-field dense label="Prima Total" color="textbox"
                                                :value="`$ ${obModal.prima}`" outlined readonly />
                                    </v-col>
                              </v-row>

                              <v-row dense>
                                    <v-col cols="12" sm="12">
                                          <v-list two-line subheader>
                                                <v-subheader inset>Documentos</v-subheader>

                                                <v-list-item v-for="item in listFile" :key="item.title"
                                                      @click="verFile(item)">
                                                      <v-list-item-avatar>
                                                            <v-icon :class="[item.iconClass]" v-text="item.icon">
                                                            </v-icon>
                                                      </v-list-item-avatar>

                                                      <v-list-item-content>
                                                            <v-list-item-title v-text="item.title"></v-list-item-title>
                                                      </v-list-item-content>

                                                      <v-list-item-action>
                                                            <v-btn icon>
                                                                  <v-icon color="primary">visibility</v-icon>
                                                            </v-btn>
                                                      </v-list-item-action>
                                                </v-list-item>
                                          </v-list>
                                    </v-col>
                              </v-row>

                              <v-row dense>
                                    <v-col cols="12" sm="4">
                                          <v-autocomplete dense label="Forma de Pago *" color="textbox" v-model="obModal.idFormaPago"
                                                :items="_.filter(listGeneral.listTipoFormaPago,(v)=>{ return !_.isNull(v.value) })" outlined readonly/>
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                          <v-text-field label="N° Cuotas *" color="textbox" v-model="obModal.nroCuota"
                                                outlined dense readonly/>
                                    </v-col>

                                    <v-col cols="12" sm="4">
                                          <v-text-field label="Cuota Inicio *" color="textbox" v-model="obModal.cuotaInicio"
                                                outlined dense readonly/>
                                    </v-col>
                              </v-row>

                              <v-row dense>
                                    <v-col cols="12" sm="12">
                                          <v-data-table :headers="listGeneral.cabeceraModal" 
                                                :items="listGeneral.detalleModal" class="elevation-3"
                                                hide-default-footer
                                                >

                                                <template v-slot:item.valor="{ item }">
                                                      {{ `$ ${Number.parseFloat(_.round(item.valor,2)).toFixed(2)}` }}
                                                </template>

                                                <template v-slot:body.append>
                                                      <tr>
                                                            <td>
                                                                  <span class="font-weight-black"
                                                                        v-html="'Total'"></span>
                                                            </td>
                                                            <td>
                                                                  <span class="font-weight-black"
                                                                        v-html="`$ ${Number.parseFloat(_.sumBy(listGeneral.detalleModal,(v)=>{ return _.toNumber(v.valor) })).toFixed(2) }`">
                                                                  </span>
                                                            </td>
                                                            <td></td>
                                                      </tr>
                                                </template>
                                          </v-data-table>
                                    </v-col>
                              </v-row>

                              <v-row dense>
                                    <v-col cols="12">
                                          <modalPdfComponent :mostrar="objPdf.mostrar" :base64="objPdf.base64"
                                                :titulo="objPdf.titulo" />
                                    </v-col>
                              </v-row>

                              <v-row dense>
                                    <v-col cols="12" class="text-right">
                                          <v-btn outlined rounded class="mr-1" @click="close">Cancelar</v-btn>
                                    </v-col>
                              </v-row>
                        </v-container>

                  </v-card-text>
            </v-card>
      </v-dialog>
</template>

<script>
      export default {
            name: 'ModalInformePolizaTradicionalComponent',
            components: {
                  modalPdfComponent: () => import('@/components/utilites/modalComponent.vue')
            },
            inject: ['close'],
            props: {
                  open: {
                        type: Boolean,
                        default: false
                  },
                  listGeneral: {
                        type: Object,
                        default: {}
                  },
                  obModal: {
                        type: Object,
                        default: {}
                  },
            },
            data: () => ({
                  objPdf: {
                        mostrar: false,
                        base64: '',
                        titulo: ''
                  },
            }),
            computed: {
                  listFile() {
                        var l = _.get(this.listGeneral, 'listDocumentos', []);

                        return _.map(l, (v) => {
                              return {
                                    title: _.startCase(_.split(v.file, '.pdf')[0]),
                                    iconClass: 'blue white--text',
                                    icon: 'assignment',
                                    path: v.path
                              }
                        });
                  }
            },
            methods: {
                  verFile(v) {
                        axios.post(`${BASE_URI}administrador/repository-file/listar`, { 'path': v.path })
                              .then((r) => {
                                    if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                                    if (_.size(_.get(r, ['data', 'data'], [])) == 0) throw 'Error al leer el archivo PDF.';
                                          this.objPdf.base64 = JSON.parse(JSON.stringify(r.data.data));
                                          this.objPdf.titulo = v.title;
                                          this.objPdf.mostrar = true;
                              })
                              .catch((e) => {
                                    mensajesAlerta(e, 'E');
                              })
                  },
                  cerrarModalPdf() {
                        this.objPdf.mostrar = false;
                        this.objPdf.base64 = '';
                  }
            },
            provide() {
                  return {
                        cerrarModalPdf: this.cerrarModalPdf
                  }
            }
      }
</script>